import React, { Component } from "react";

/* Bootstrap Components */
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

/* Others */
import logo from "../../../assets/logo_solo.png";
import { IoLogoWhatsapp } from "react-icons/io";
import {
  FaTwitter,
  FaLinkedin,
  FaFacebook,
  FaInstagram,
  FaEnvelope,
} from "react-icons/fa";
import {AiFillInstagram} from "react-icons/ai"
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  EmailShareButton,
  InstapaperShareButton,
} from "react-share";
/* Styled */
import { StyleBrand, StyledUlSocial } from "./styled";

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: "Vivo",
      modal: false,
    };
  }
  openModal = () => {
    this.setState({ modal: true });
  };

  closeModal = () => {
    this.setState({ modal: false });
  };

  render() {
    return (
      <>
        <Navbar collapseOnSelect expand="lg" bg="light" variant="light">
          <Container fluid={true}>
            <Row>
              <Col className="m-2" style={{ paddingRight: "0" }}>
                <StyleBrand>
                  <a href="https://chequeado.com">
                    <img src={logo} className="img-responsive" alt="logo" />
                  </a>
                </StyleBrand>
              </Col>
            </Row>
            <Navbar.Toggle
              aria-controls="responsive-navbar-nav"
              style={{ outline: "0" }}
            />
            <Navbar.Collapse id="responsive-navbar-nav">
              <Nav className="mr-auto" style={{ marginRight: "auto" }}></Nav>
              <Nav>
                <ul>
                  <p
                    style={{
                      marginBottom: "5px",
                      textAlign: "right",
                      marginRight: "15px",
                      fontSize: "10px",
                    }}
                  >
                    Si te gustó, compartilo
                  </p>
                  <StyledUlSocial>
                    <li>
                      <EmailShareButton
                        url={`https://chequeado.com/herramientasparaperiodistas`}
                        title={"LatamChequea"}
                      >
                        <FaEnvelope size={30} />
                      </EmailShareButton>
                    </li>
                    <li>
                      <FacebookShareButton
                        url={`https://chequeado.com/herramientasparaperiodistas`}
                      >
                        <FaFacebook size={30} />
                      </FacebookShareButton>
                    </li>
                    <li>
                      <a
                        href="https://instagram.com/chequeado"
                        target="_blank"
                        rel="noreferrer"
                        style={{ cursor: "pointer", color: "#212529" }}
                      >
                        <AiFillInstagram size={35} />
                      </a>
                    </li>
                    <li>
                      <TwitterShareButton
                        url={`https://chequeado.com/herramientasparaperiodistas`}
                        title={"LatamChequea"}
                      >
                        <FaTwitter size={30} />
                      </TwitterShareButton>
                    </li>
                    <li>
                      <WhatsappShareButton
                        url={`https://chequeado.com/herramientasparaperiodistas`}
                      >
                        <IoLogoWhatsapp size={30} />
                      </WhatsappShareButton>
                    </li>
                    <li>
                      <LinkedinShareButton
                        url={`https://chequeado.com/herramientasparaperiodistas`}
                      >
                        <FaLinkedin size={30} />
                      </LinkedinShareButton>
                    </li>
                  </StyledUlSocial>
                </ul>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </>
    );
  }
}

export default Header;
